// File copied from https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/static-3.1128/js/core/Color.ts
import isNaN from 'hs-lodash/isNaN';
const RGB_REGEX = /^rgb/i;

/**
 * Returns the RGB channel values for a given color
 * @param {string} color - A color in hex, rgb(), or rgba() format
 * @returns {object} An object of the form { r, g, b }
 */
export function getRGB(color) {
  let r;
  let g;
  let b;

  try {
    if (RGB_REGEX.test(color)) {
      const match = color.match(/(\d+)\D+(\d+)\D+(\d+)/);
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
    } else {
      let hexColor = color.toLowerCase().replace(/^#/, '');
      if (hexColor.length === 3) hexColor = hexColor.replace(/([0-9a-f])/g, '$1$1');
      r = parseInt(hexColor.substring(0, 2), 16);
      g = parseInt(hexColor.substring(2, 4), 16);
      b = parseInt(hexColor.substring(4, 6), 16);
    }

    if ([r, g, b].some(isNaN)) return {};
  } catch (err) {
    return {};
  }

  return {
    r,
    g,
    b
  };
}
/**
 * @param {string} color - A color in hex, rgb(), or rgba() format
 * @param {number} opacity - A number between 0 (transparent) and 1 (opaque)
 * @returns {string} A string of the form "rgba(255, 150, 51, 0.75)"
 */

export function rgba(color, opacity = 1) {
  const {
    r,
    g,
    b
  } = getRGB(color);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}